/**
 * @generated SignedSource<<4cf076d72eaaaaa2d60ff500fb866c73>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useUserOverrides_user$data = {
  readonly id: string;
  readonly overrides: {
    readonly id: string;
    readonly overridesMap: any | null;
  } | null;
  readonly " $fragmentType": "useUserOverrides_user";
};
export type useUserOverrides_user$key = {
  readonly " $data"?: useUserOverrides_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"useUserOverrides_user">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useUserOverrides_user",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Overrides",
      "kind": "LinkedField",
      "name": "overrides",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "overridesMap",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "a2adb200945468e27cc0176932e68f97";

export default node;
